import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/account";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav(next);
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };

  const googleAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    sessionStorage.setItem("goshi_auth_next", next);
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="pt-32 pb-24 px-6 md:px-12 min-h-screen flex items-center justify-center">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center space-y-3">
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Account</p>
          <h1 className="font-serif text-5xl">Sign In</h1>
        </div>

        <form onSubmit={submit} className="space-y-6" data-testid="login-form">
          <input className="input-line" type="email" placeholder="Email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="login-email" />
          <input className="input-line" type="password" placeholder="Password" required value={password} onChange={e => setPassword(e.target.value)} data-testid="login-password" />
          <button type="submit" className="btn-gold w-full" disabled={busy} data-testid="login-submit">{busy ? "Signing in…" : "Sign In"}</button>
        </form>

        <div className="flex items-center gap-4">
          <div className="flex-1 h-px bg-[rgba(244,244,240,0.06)]" />
          <span className="text-xs uppercase tracking-[0.2em] text-muted">Or</span>
          <div className="flex-1 h-px bg-[rgba(244,244,240,0.06)]" />
        </div>

        <button onClick={googleAuth} className="btn-outline w-full" data-testid="google-auth-btn">
          Continue with Google
        </button>

        <p className="text-center text-sm text-muted">
          New to GOSHI? <Link to="/register" className="text-gold underline-offset-4 hover:underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
